import { useState, virtual, useEffect, useMemo } from 'haunted';
import { Customize } from '../index.js';
import { Loading } from '../../loading/index.js';
import { locale } from '@local/config';
import { getI18n } from '../_i18n/i18n.js';

export const customizeAppPlayer = virtual(
  ({ url, component: ComponentPlayer }) => {
    const [playlist, setPlaylist] = useState(null);
    const [accent, setAccent] = useState('neutral');
    const [showCovers, setShowCovers] = useState(true);
    const [showTrackNumber, setShowTrackNumber] = useState(true);
    const [showFileExtension, setShowFileExtension] = useState(true);
    const [trackInfoHorizontal, setTrackInfoHorizontal] = useState('left');

    const currentLocale = locale();

    const literals = useMemo(
      () => getI18n(currentLocale) ?? getI18n('en'),
      [currentLocale]
    );

    useEffect(() => {
      fetch(url)
        .then(response => response.json())
        .then(data => setPlaylist(data));
    }, []);

    return playlist
      ? Customize({
          prefsBasic: [
            {
              type: 'check',
              title: literals.showCovers,
              name: 'covers',
              pref: showCovers,
              setPref: setShowCovers
            },
            {
              type: 'check',
              title: literals.showTrackNumber,
              name: 'track-number',
              pref: showTrackNumber,
              setPref: setShowTrackNumber
            },
            {
              type: 'check',
              title: literals.showFileExtension,
              name: 'file-extension',
              pref: showFileExtension,
              setPref: setShowFileExtension
            },
            {
              type: 'radio',
              title: literals.trackInfoAlign,
              name: 'track-info-align',
              options: [
                { label: literals.trackInfoAlignLeft, value: 'left' },
                { label: literals.trackInfoAlignRight, value: 'right' }
              ],
              pref: trackInfoHorizontal,
              setPref: setTrackInfoHorizontal
            }
          ],
          prefsAccent: { accent, setAccent },
          component: ComponentPlayer,
          componentAccent: accent,
          componentProps: {
            lang: currentLocale,
            extraClasses: `rounded-lg relative overflow-hidden shadow-2xl`,
            playlist,
            playlistAlign: trackInfoHorizontal,
            showArtwork: showCovers,
            showTrackNumber,
            showFileExtension
          }
        })
      : Loading();
  }
);
